<template>
  <div class="cuerpo card card-body">
    <div class="seccion">
      <span class="titulo">Buscar por</span>
      <div class="btn-group-vertical">
        <input
          type="radio"
          class="btn-check"
          name="radiobuscar"
          id="radiobuscar1"
          autocomplete="off"
          checked
          :value="1"
          v-model="buscarPor"
        />
        <label class="btn btn-outline-primary" for="radiobuscar1"
          >Comercio</label
        >

        <input
          type="radio"
          class="btn-check"
          name="radiobuscar"
          id="radiobuscar2"
          autocomplete="off"
          :value="2"
          v-model="buscarPor"
        />
        <label class="btn btn-outline-primary" for="radiobuscar2"
          >Beneficio</label
        >

        <input
          type="radio"
          class="btn-check"
          name="radiobuscar"
          id="radiobuscar3"
          autocomplete="off"
          :value="3"
          v-model="buscarPor"
        />
        <label class="btn btn-outline-primary" for="radiobuscar3"
          >Categoría</label
        >

        <input
          type="radio"
          class="btn-check"
          name="radiobuscar"
          id="radiobuscar4"
          autocomplete="off"
          :value="4"
          v-model="buscarPor"
        />
        <label class="btn btn-outline-primary" for="radiobuscar4"
          >Localidad</label
        >
      </div>
    </div>
    <div class="seccion">
      <span class="titulo">Ordenar por</span>
      <div class="btn-group-vertical">
        <input
          type="radio"
          class="btn-check"
          name="btnradio"
          id="btnradio1"
          autocomplete="off"
          checked
          :value="1"
          v-model="ordenarPor"
        />
        <label class="btn btn-outline-primary" for="btnradio1"
          >Relevancia</label
        >

        <input
          type="radio"
          class="btn-check"
          name="btnradio"
          id="btnradio2"
          autocomplete="off"
          :value="2"
          v-model="ordenarPor"
        />
        <label class="btn btn-outline-primary" for="btnradio2">Novedad</label>
        <!-- No implementado -->
        <!-- 
        <input
          type="radio"
          class="btn-check"
          name="btnradio"
          id="btnradio3"
          autocomplete="off"
          :value="3"
          v-model="ordenarPor"
        />
        <label class="btn btn-outline-primary" for="btnradio3"
          >Mayor descuento</label
        > -->

        <input
          type="radio"
          class="btn-check"
          name="btnradio"
          id="btnradio3"
          autocomplete="off"
          :value="3"
          v-model="ordenarPor"
        />
        <label class="btn btn-outline-primary" for="btnradio3"
          >Calificación</label
        >

        <input
          type="radio"
          class="btn-check"
          name="btnradio"
          id="btnradio4"
          autocomplete="off"
          :value="4"
          v-model="ordenarPor"
        />
        <label class="btn btn-outline-primary" for="btnradio4">Descuento</label>
      </div>
    </div>
  </div>
</template>
<script>
const EVENTO_BUSCARPOR = "cambio-buscar-por";
const EVENTO_ORDENARPOR = "cambio-ordenar-por";

export default {
  name: "Filtro",
  components: {},
  props: {},
  data() {
    return {
      buscarPor: 1,
      ordenarPor: 1,
    };
  },
  computed: {},
  watch: {
    buscarPor(valor) {
      this.$emit(EVENTO_BUSCARPOR, valor);
    },
    ordenarPor(valor) {
      this.$emit(EVENTO_ORDENARPOR, valor);
    },
  },
  methods: {},
};
</script>
<style scoped>
.cuerpo {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  border: none;
}

.seccion {
  margin-left: 5px;
  margin-right: 5px;
  display: flex;
  flex-direction: column;
  width: 150px;
  font-size: 13px;
}
.seccion:first-child {
  margin-bottom: 10px;
}

.seccion label {
  font-size: 13px;
  margin-bottom: 0;
}

@media (min-width: 576px) {
  .seccion:first-child {
    margin-bottom: 0;
  }
}

@media (min-width: 768px) {
  .cuerpo {
    justify-content: flex-start;
  }
}
</style>